import React, { useLayoutEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Paper } from "@mui/material";
import { Close } from "@mui/icons-material";
import QRCodeDialog from "../app/home/dialog/dialogBody/QRCode.dialog";
import { TYPE } from "../../utils/Utils";
import VerifyInsuranceDialog from "../app/home/dialog/dialogBody/VerifyInsurance.dialog";
import QuoteQuestionsComponent from "../app/verification/QuoteQuestions.component";

const DialogComponent = (props) => {
  const [dialogTitle, setDialogTitle] = useState(null);
  const [dialogBody, setDialogBody] = useState(null);
  const { onClose, open, maxWidth = "sm", showButton = true, sx } = props;

  useLayoutEffect(() => {
    if (props.bodyType === TYPE.QR) {
      setDialogTitle("QR Code");
      // setDialogBody(<QRCodeDialog />);
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.VERIFY) {
      setDialogTitle("Verify Insurance");
      setDialogBody(<VerifyInsuranceDialog onClose={onClose} />);
    } else if (props.bodyType === TYPE.API_LOG) {
      setDialogTitle("DeliveryIQ+ Health Report");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.DOCUMENT) {
      setDialogTitle(props.title);
      // setDialogTitle("Insurance Load Sheet");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.ADD_USER) {
      setDialogTitle("Add User");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.UPDATE_USER) {
      setDialogTitle("Update User");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.YMM) {
      setDialogTitle("Vehicle Information");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.PRIVACY_POLICY) {
      setDialogTitle("Privacy Policy");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.USER_TERMS) {
      setDialogTitle("Terms of Use");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.CUSTOMER_INFO) {
      setDialogTitle("Customer Information");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.PULL_DETAILS) {
      setDialogTitle("Pull Details");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.EDIT_DEALERSHIP) {
      setDialogTitle("Edit Dealership");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.UPDATE_SUBSCRIPTION) {
      setDialogTitle("Update Subscription");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.CREATE_DEALERSHIP) {
      setDialogTitle("Create Dealership");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.EMAIL_BILLING) {
      setDialogTitle("Email Billing");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.OUTPUT_PAYLOAD) {
      setDialogTitle("Output Payload");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.CANOPY_ERROR) {
      setDialogTitle("Error Details");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.UPDATE_USER) {
      setDialogTitle("Update User");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.CREATE_USER) {
      setDialogTitle("Create User");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.LOG_OUT) {
      setDialogTitle("Log Out");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.DEACTIVATE_DEALER) {
      setDialogTitle("Dealership Status");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.PROMOTE_EMPLOYEE) {
      setDialogTitle("Promote Employee");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.IMPORT_USERS) {
      setDialogTitle("Import Users");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.QUOTE_QUESTIONS) {
      setDialogTitle("Questions that will make your quote super easy!");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.LOGOUT) {
      setDialogTitle("Warning");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.UPLOAD_LOGO) {
      setDialogTitle("Upload Logo");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.CUSTOMER_DETAILS) {
      setDialogTitle("Customer Details");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.REPULL_DETAILS) {
      setDialogTitle("Repull Insurance");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.SERVICES) {
      setDialogTitle("Services");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.ARTIFACTS) {
      setDialogTitle("Artifacts");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.ACCESS_DENIED) {
      setDialogTitle("Access Denied");
      setDialogBody(props.body);
    } else if (props.bodyType === TYPE.KNOWLEDGE_HUB) {
      setDialogTitle("Knowledge Hub");
      setDialogBody(props.body);
    } else {
      setDialogTitle(props.title);
      setDialogBody(props.body);
    }
  }, [props]);

  return (
    <Dialog
      sx={sx}
      onClose={onClose}
      open={open}
      showButton={showButton}
      fullWidth={false}
      maxWidth={maxWidth}
      scroll={"paper"}
      PaperProps={{
        style: {
          borderRadius: "6px",
          width: "100%",
        },
      }}
      fullScreen={
        (props.bodyType === TYPE.QUOTE_QUESTIONS && window.innerWidth <= 750) ||
        (props.bodyType === TYPE.SERVICES && window.innerWidth <= 750)
          ? true
          : false
      }
    >
      <DialogTitle
        style={{
          background: "#fff",
          color: "#000",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: window.innerWidth <= 750 ? "15px" : null,
          }}
        >
          {dialogTitle}
          <Close
            sx={{ alignSelf: "center", cursor: "pointer" }}
            onClick={onClose}
          />
        </Box>
      </DialogTitle>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "8px",
          overflowY: "scroll",
        }}
      >
        {dialogBody}
      </Box>
    </Dialog>
  );
};

export default DialogComponent;
